import { useState, useEffect } from "react";

const LATAM_COUNTRIES = [
    "AR", // Argentina
    "BO", // Bolivia
    "BR", // Brazil
    "CL", // Chile
    "CO", // Colombia
    "CR", // Costa Rica
    "CU", // Cuba
    "DO", // Dominican Republic
    "EC", // Ecuador
    "SV", // El Salvador
    "GT", // Guatemala
    "HN", // Honduras
    "MX", // Mexico
    "NI", // Nicaragua
    "PA", // Panama
    "PY", // Paraguay
    "PE", // Peru
    "UY", // Uruguay
    "VE", // Venezuela
];

export function useGeoLocation() {
    const [country, setCountry] = useState(null);
    const [isLatam, setIsLatam] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const detectCountry = async () => {
            try {
                // Try to get from localStorage cache first (valid for 24h)
                const cached = localStorage.getItem("geo_country");
                if (cached) {
                    const { country, timestamp } = JSON.parse(cached);
                    const isValid = Date.now() - timestamp < 24 * 60 * 60 * 1000;
                    if (isValid) {
                        setCountry(country);
                        setIsLatam(LATAM_COUNTRIES.includes(country));
                        setIsLoading(false);
                        return;
                    }
                }

                // Use free IP geolocation API
                const response = await fetch("https://ipapi.co/json/");
                const data = await response.json();
                const countryCode = data.country_code;

                // Cache the result
                localStorage.setItem("geo_country", JSON.stringify({
                    country: countryCode,
                    timestamp: Date.now(),
                }));

                setCountry(countryCode);
                setIsLatam(LATAM_COUNTRIES.includes(countryCode));
            } catch (error) {
                console.error("Failed to detect country:", error);
                setCountry(null);
                setIsLatam(false);
            } finally {
                setIsLoading(false);
            }
        };

        detectCountry();
    }, []);

    return { country, isLatam, isLoading };
}

export { LATAM_COUNTRIES };
